import React from 'react';

const LoadingForComponent = ({ isLoading = true, login = false }) => {
  return (
    <div className={`${login ? '' : 'card'} `}>
      <div
        className={`mr-4 ${
          login ? 'modalCompLoadingLogin' : 'modalCompLoadingBanner'
        } `}
        style={{ display: isLoading ? 'flex' : 'none' }}
      >
        <button type="button" className="btn btn-primary disabled">
          <span>
            <div className="spinner-grow"></div>
            <div className="spinner-grow"></div>
            <div className="spinner-grow"></div>
          </span>
        </button>
      </div>
    </div>
  );
};

export default LoadingForComponent;
